import { DateTime } from 'luxon';

export function getTimeZone() {
    let offset = new Date().getTimezoneOffset(),
        o = Math.abs(offset);
    return (
        (offset < 0 ? '+' : '-') +
    ('00' + Math.floor(o / 60)).slice(-2) +
    ':' +
    ('00' + (o % 60)).slice(-2)
    );
}

export function getFormattedDate() {
    var utcStr = new Date();
    let formatedDate = utcStr.toISOString().split('T');
    let formateDateinHMS = formatedDate[1].split('Z');
    let finalDate = formatedDate[0] + ' ' + formateDateinHMS[0] + getTimeZone();
    return finalDate;
}

export function formatDateMMYY(date) {
    return `${date.getUTCMonth() + 1}/${date.getUTCFullYear()}`;
}

export function formatDateMMDDYY(date) {
    // Use UTC methods to prevent timezone conversion
    return `${
        date.getUTCMonth() + 1
    }/${date.getUTCDate()}/${date.getUTCFullYear()}`;
}

export function formatDateMMDDYYLocal(date) {
    return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
}

export const formatDateYYYYMMDDPacific = (date) =>
    new Intl.DateTimeFormat('en-CA', {
        timeZone: 'America/Los_Angeles',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).format(date);

export function formatDateMMDDYYPacific(date) {
    return new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        timeZone: 'America/Los_Angeles',
    }).format(date);
}

export function formatDateMonthYYYY(date) {
    return new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: 'long',
        timeZone: 'America/Los_Angeles',
    }).format(date);
}

export function formatDateMonthDDYYYY(date) {
    return new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        timeZone: 'America/Los_Angeles',
    }).format(date);
}

export function getMonthsBetween(
    date1,
    date2,
    roundUpFractionalMonths = false,
) {
    var startDate = date1;
    var endDate = date2;
    var inverse = false;
    if (date1 > date2) {
        startDate = date2;
        endDate = date1;
        inverse = true;
    }

    var yearsDifference = endDate.getFullYear() - startDate.getFullYear();
    var monthsDifference = endDate.getMonth() - startDate.getMonth();
    var daysDifference = endDate.getDate() - startDate.getDate();

    var monthCorrection = 0;
    if (roundUpFractionalMonths === true && daysDifference > 0) {
        monthCorrection = 1;
    } else if (roundUpFractionalMonths !== true && daysDifference < 0) {
        monthCorrection = -1;
    }

    return (
        (inverse ? -1 : 1) *
    (yearsDifference * 12 + monthsDifference + monthCorrection)
    );
}

export function getDaysBetween(d1, d2) {
    return Math.ceil(
        DateTime.fromJSDate(d2).diff(DateTime.fromJSDate(d1), 'days').days,
    );
}

export function getPacificDateFromInput(inputValue) {
    const dt = DateTime.fromISO(inputValue, {
        zone: 'America/Los_Angeles',
    }).startOf('day');
    return dt.toJSDate();
}

export function getPacificDateFromInputWithDifference(
    inputValue,
    daysToSubtract,
) {
    const pacificDt = DateTime.fromISO(inputValue, {
        zone: 'America/Los_Angeles',
    }).startOf('day');
    const subtracted = pacificDt.minus({ days: daysToSubtract }).toJSDate();
    return subtracted;
}

export function groupByRollingWeeks(data, weeks, field) {
    const now = DateTime.now().startOf('day');

    const groups = data.reduce((acc, item) => {
        const dt = DateTime.fromJSDate(item[field]).startOf('day');

        const daysAgo = Math.floor(now.diff(dt, 'days').days);

        if (daysAgo < 0) return acc; // future
        const bucket = Math.floor(daysAgo / 7);

        if (bucket >= weeks) return acc; // outside range

        acc[bucket] ??= [];
        acc[bucket].push(item);

        return acc;
    }, {});
    const weekgroups = Object.entries(groups).map(([week, items]) => ({
        week,
        items,
    }));
    return weekgroups;
}
